<template>
  <div class="ppst">
    <div class="banner min-container" :style="bannerImg"></div>
    <div class="content min-container">
      <div class="container">
        <transition name="el-fade-in">
          <div class="ppst-float" :class="{fixed : toFixed}" v-if="showFloat">
            <div class="realtime" :style="realtimeImg" @click="toRealTime()" v-ga="$ga.commands.trackName.bind(this, 'pcFloatRealtime')">
              <div class="realtime_scroll">
                <vue-seamless-scroll :data="newsList" :class-option="optionLeft" class="realtime_scroll_seam">
                  <div class="item" :style="scroll_style">
                    <p class="scroll_p" v-for="item in newsList" :key="item.rank">
                    {{ item.rank | format_rank }}{{ '&nbsp;&nbsp;' + item.point + '&nbsp;&nbsp;' + item.uid + '&nbsp;&nbsp;' + item.nickname  }}
                    </p>
                  </div>

                </vue-seamless-scroll>
              </div>
            </div>

            <div class="tab_side">
              <div class="tab_side_item" :class="{ active: floatItem === 'leaderboard'}" @click="changeFloatItem('leaderboard')" v-ga="$ga.commands.trackName.bind(this, 'pcFloatLeaderboard')">
                <p>{{ $t('ppst.p12') }}</p>
              </div>
              <div class="tab_side_item" :class="{ active: floatItem === 'prizetable'}" @click="changeFloatItem('prizetable')" v-ga="$ga.commands.trackName.bind(this, 'pcFloatprizetable')">
                <p>{{ $t('ppst.p19') }}</p>
              </div>
              <!-- <div class="tab_side_item" :class="{ active: floatItem === 'schedule'}" @click="changeFloatItem('schedule')" v-ga="$ga.commands.trackName.bind(this, 'pcFloatSchedule')">
                <p>{{ $t('ppst.p32') }}</p>
              </div> -->
              <div class="tab_side_item" :class="{ active: floatItem === 'faq'}" @click="changeFloatItem('faq')" v-ga="$ga.commands.trackName.bind(this, 'pcFloatFaq')">
                <p>{{ $t('ppst.p33') }}</p>
              </div>
            </div>


            <a v-if="lang === 'en'" href="https://bit.ly/3fyIyie" target="_blank" v-ga="$ga.commands.trackName.bind(this, 'pcFloatFacebook')"><img class="join_img" :src="'/ppst/static/img/ppst/JoinFacebookgroup_' + lang + '.png'" /></a>

            <a v-if="lang === 'pt'" href="https://bit.ly/2W5vnh0" target="_blank" v-ga="$ga.commands.trackName.bind(this, 'pcFloatInstagram')"><img class="join_img" :src="'/ppst/static/img/ppst/JoinFacebookgroup_' + lang + '.png'" /></a>

            <p class="tab_tips">{{ $t('ppst.p77') }}</p>
          </div>
        </transition>

        <div class="content-right ppst-color-para">
          <p class="title ppst-color-main toleaderboard"><img src="/ppst/static/img/ppst/title_icon.png" /> {{ $t('ppst.p12') }}</p>
          <div class="line-green"></div>
          <p>{{ $t('ppst.p5') }}</p>
          <p>{{ $t('ppst.p6') }}</p>
          <i18n path="ppst.p10" tag="p">
            <template slot="link">
              <a class="to_link" target="_blank" href="https://www.pppoker.net/?utm_source=PPSTLeaderboard&utm_medium=pppokerhomepage&utm_campaign=pppstleaderboard#/home
              ">PPPoker</a>
            </template>
          </i18n>
          <div class="leaderboard">
            <div class="tab">
              <div class="tab_item" :class="{ active: leaderstatus === 'overall'}" @click="changeLeader('overall')">
                <p>{{ $t('ppst.p13') }}</p>
              </div>
              <div class="tab_item" :class="{ active: leaderstatus === 'realtime'}" @click="changeLeader('realtime')">
                <p>{{ $t('ppst.p18') }}</p>
              </div>

              <div class="serach" v-show="leaderstatus === 'overall'">
                <input class="serach_input" :placeholder="$t('ppst.p72') + '(UID)'" v-model="inputOverSearch" @input="debounce(toSearch, 800)()" />
              </div>
              <div class="serach" v-show="leaderstatus === 'realtime'">
                <input class="serach_input" :placeholder="$t('ppst.p72') + '(UID)'" v-model="inputRealSearch" @input="debounce(toSearch, 800)()" />
              </div>
            </div>

          </div>
          <div v-show="leaderstatus === 'overall'">
            <div class="leadertable"  v-bar >
              <div class="table">
                <div class="table-header">
                  <div class="td td1">
                    <p>{{ $t('ppst.p14') }}</p>
                  </div>
                  <div class="td td2">
                    <p>{{ $t('ppst.p15') }}</p>
                  </div>
                  <div class="td td5">
                    <p>UID</p>
                  </div>
                  <div class="td td3">
                    <p>{{ $t('ppst.p16') }}</p>
                  </div>
                  <div class="td td_geo_h">
                    <p>GEO</p>
                  </div>
                  <div class="td td4">
                    <p>{{ $t('ppst.p17') }}</p>
                  </div>
                </div>

                <div v-for="(item, index) in leaderOverList" :key="index" class="table-item">
                  <div class="td td1">
                    <p>{{ item.rank }}</p>
                  </div>
                  <div class="td td2">
                    <p>{{ item.point }}</p>
                  </div>
                  <div class="td td5">
                    <p>{{ item.uid }}</p>
                  </div>
                  <div class="td td3">
                    <p>{{ item.nickname.length > 20 ? item.nickname.substring(0, 20) + '...' : item.nickname }}</p>
                  </div>
                  <div class="td td_geo">
                    <img v-if="item.country" :src="'/ppst/static/img/ppst/flag/' + item.country + '.png'" />
                  </div>
                  <div class="td td4">
                    <p>{{ item.price }}</p>
                  </div>
                </div>
                <div v-if="leaderOverList.length === 0">
                  <div class="no_record">
                    <p class="no_record_p"><img src="/ppst/static/img/ppst/noseach_icon_pc.png" /> <span>No records found</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="leaderstatus === 'realtime'">
            <div class="realtimetable"  v-bar >
              <div class="table">
                <div class="table-header">
                  <div class="td td1">
                    <p>{{ $t('ppst.p14') }}</p>
                  </div>
                  <div class="td td2">
                    <p>{{ $t('ppst.p15') }}</p>
                  </div>
                  <div class="td td5">
                    <p>UID</p>
                  </div>
                  <div class="td td3">
                    <p>{{ $t('ppst.p16') }}</p>
                  </div>
                  <div class="td td_geo_h">
                    <p>GEO</p>
                  </div>
                  <!-- <div class="td td4">
                    <p>{{ $t('ppst.p17') }}</p>
                  </div> -->
                </div>

                <div v-for="(item, index) in leaderRealList" :key="index" class="table-item">
                  <div class="td td1">
                    <p>{{ item.rank }}</p>
                  </div>
                  <div class="td td2">
                    <p>{{ item.point }}</p>
                  </div>
                  <div class="td td5">
                    <p>{{ item.uid }}</p>
                  </div>
                  <div class="td td3">
                    <p>{{ item.nickname.length > 20 ? item.nickname.substring(0, 20) + '...' : item.nickname }}</p>
                  </div>
                  <div class="td td_geo">
                    <img v-if="item.country" :src="'/ppst/static/img/ppst/flag/' + item.country + '.png'" />
                  </div>
                  <!-- <div class="td td4">
                    <p>{{ item.price }}</p>
                  </div> -->
                </div>

                <div v-if="leaderRealList.length === 0">
                  <div class="no_record">
                    <p class="no_record_p"><img src="/ppst/static/img/ppst/noseach_icon_pc.png" /> <span>No records found</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p v-show="leaderstatus === 'realtime' && main_cycle.start_date" class="realtime_tips">
            <template v-if="lang === 'en'">*The present real-time board shows the points calculated from {{ main_cycle.start_date | parseTime }} till {{ main_cycle.end_date | parseTime }}.</template>
            <template v-if="lang === 'pt'">*Esta classificação em tempo real mostra os pontos calculados de {{ main_cycle.start_date | parseTime }} abril até {{ main_cycle.end_date | parseTime }}.</template>
          </p>


          <p class="title ppst-color-second toprizetable"><img src="/ppst/static/img/ppst/title_icon.png" /> {{ $t('ppst.p19') }}</p>
          <div class="line-blue"></div>
          <p>{{ $t('ppst.p20') }}</p>
          <p>{{ $t('ppst.p21') }}</p>
          <img class="prizetable_img" width="100%" :src="'/ppst/static/img/ppst/prizetable_' + lang + '.png'" />

          <!-- <p class="title ppst-color-main toschedule"><img src="/ppst/static/img/ppst/title_icon.png" /> {{ $t('ppst.p32') }}</p>
          <div class="line-green"></div>

          <zone-select v-if="lang === 'en'"></zone-select>
          <zone-select-pt v-if="lang === 'pt'"></zone-select-pt>
          <schedule ref="schedule"></schedule> -->

          <p class="title ppst-color-main tofaq"><img src="/ppst/static/img/ppst/title_icon.png" /> {{ $t('ppst.p33') }}</p>
          <div class="line-green"></div>
          <div class="div-faq">
            <p><img src="/ppst/static/img/ppst/FAQ_dot.png" />{{ $t('ppst.p37') }}</p>
            <p>{{ $t('ppst.p38') }}</p>
            <br />
            <p><img src="/ppst/static/img/ppst/FAQ_dot.png" />{{ $t('ppst.p39') }}</p>
            <p>{{ $t('ppst.p40') }}</p>
            <br />
            <p><img src="/ppst/static/img/ppst/FAQ_dot.png" />{{ $t('ppst.p41') }}</p>
            <p>{{ $t('ppst.p49') }}</p>
            <p>{{ $t('ppst.p50') }}</p>
            <p>{{ $t('ppst.p51') }}</p>
            <p>{{ $t('ppst.p52') }}</p>
            <p>{{ $t('ppst.p53') }}</p>
            <p>{{ $t('ppst.p54') }}</p>
            <p>{{ $t('ppst.p55') }}</p>
            <p>{{ $t('ppst.p56') }}</p>
            <br />
            <p><img src="/ppst/static/img/ppst/FAQ_dot.png" />{{ $t('ppst.p57') }}</p>
            <p>{{ $t('ppst.p58') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import vueSeamlessScroll from 'vue-seamless-scroll'
  import zoneSelect from './ppst/zoneSelect'
  import zoneSelectPt from './ppst/zoneSelectPt'
  import schedule from './ppst/schedule'
  import {
    get_leader_board_list,
    get_leader_board_user,
    get_leader_board_cycle
  } from '@/api/official'

  export default {
    data() {
      return {
        leaderstatus: 'overall',
        floatItem: 'leaderboard',
        toFixed: false,
        showFloat: true,
        inputOverSearch: '',
        inputRealSearch: '',
        newsList: [],
        optionLeft: {
          direction: 2,
          limitMoveNum: 2
        },
        leaderOverList: [
        ],
        leaderRealList: [
        ],
        lang: this.$route.params.lang || 'en',
        bannerImg: '',
        realtimeImg: '',
        over_rall_page: 0,
        real_time_page: 0,
        timer: null,
        scroll_style: {},
        main_cycle: {}
      }
    },
    components: {
      vueSeamlessScroll,
      zoneSelect,
      zoneSelectPt,
      schedule
    },
    filters: {
      format_rank: function(val) {
        if(val === 1) {
          return val + 'st'
        }else if(val === 2) {
          return val + 'nd'
        }else if(val === 3) {
          return val + 'rd'
        }else {
          return val + 'th'
        }
      },
      parseTime: function(time) {
        let date = new Date(time * 1000);
        const formatObj = {
          y: date.getFullYear(),
          m: date.getMonth() + 1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        return formatObj.m + '/' + formatObj.d
      }
    },
    methods: {
      debounce(func, wait) {
        // let timer;
        return () => {
          let context = this;
          let args = arguments;

          if (this.timer) clearTimeout(this.timer);

          this.timer = setTimeout(() => {
            func.apply(this, args)
          }, wait)
        }
      },
      changeLeader(val) {
        this.leaderstatus = val
      },
      changeFloatItem(val) {
        this.floatItem = val
        document
          .querySelector('.to' + val)
          .scrollIntoView()
      },
      toRealTime() {
        this.changeLeader('realtime')
        this.changeFloatItem('leaderboard')
      },
      toSearch() {
        if(this.leaderstatus === 'overall') {
          if(this.inputOverSearch !== '') {
            this.getUserData('overall', this.inputOverSearch)
            this.$ga.event('click', 'pcOverallSearch')
          }else {
            this.over_rall_page = 0
            this.leaderOverList = []
            this.initOverData()
          }
        }else {
          if(this.inputRealSearch !== '') {
            this.getUserData('realtime', this.inputRealSearch)
            this.$ga.event('click', 'pcRealtimeSearch')
          }else {
            this.real_time_page = 0
            this.leaderRealList = []
            this.initRealData()
          }
        }
      },
      // toFloat() {
      //   let scrollt = document.documentElement.scrollTop + document.body.scrollTop
      //   if (scrollt > 592) {
      //     // this.showFloat = true
      //     this.toFixed = true
      //     if (scrollt > 684 && scrollt < 768) {
      //       this.floatItem = 'leaderboard'
      //     }
      //     if (scrollt > 1829 && scrollt < 1913) {
      //       this.floatItem = 'prizetable'
      //     }
      //     if (scrollt > 2502 && scrollt < 2586) {
      //       this.floatItem = 'schedule'
      //     }
      //     if (scrollt > 3367 && scrollt < 3451) {
      //       this.floatItem = 'faq'
      //     }
      //     if(scrollt > 3536) {
      //       this.toFixed = false
      //     }
      //   } else {
      //     this.toFixed = false
      //     // this.showFloat = false
      //     this.floatItem = 'leaderboard'
      //   }
      // },
      toFloat() {
        let scrollt = document.documentElement.scrollTop + document.body.scrollTop
        if (scrollt > 592) {
          // this.showFloat = true
          this.toFixed = true
          if (scrollt > 684 && scrollt < 768) {
            this.floatItem = 'leaderboard'
          }
          if (scrollt > 1829 && scrollt < 1913) {
            this.floatItem = 'prizetable'
          }
          // if (scrollt > 2502 && scrollt < 2586) {
          //   this.floatItem = 'schedule'
          // }
          if (scrollt > 2480 && scrollt < 2550) {
            this.floatItem = 'faq'
          }
          if(scrollt > 2560) {
            this.toFixed = false
          }
        } else {
          this.toFixed = false
          // this.showFloat = false
          this.floatItem = 'leaderboard'
        }
      },
      // loadOverData() {
      //   this.initOverData()
      // },
      // loadRealData() {
      //   this.initRealData()
      // },
      getUserData(board_type, uid) {
        let group_type = this.lang === 'pt' ? 'brazil' : 'other'
        get_leader_board_user({
          group_type,
          board_type,
          uid
        })
          .then(res => {
            console.log(res)
            if(board_type === 'overall') {
              this.leaderOverList = res.data
            }else {
              this.leaderRealList = res.data
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      initCycle() {
        let group_type = this.lang === 'pt' ? 'brazil' : 'other'
        get_leader_board_cycle({
          group_type,
        })
          .then(res => {
            this.main_cycle = res.data.main_cycle
          })
          .catch(err => {
            console.log(err)
          })
      },
      initOverData() {
        let group_type = this.lang === 'pt' ? 'brazil' : 'other'
        this.over_rall_page = this.over_rall_page + 1
        get_leader_board_list({
          group_type,
          board_type: 'overall',
          // page: this.over_rall_page,
          size: 100
        })
          .then(res => {
            console.log(res)
            this.leaderOverList = this.leaderOverList.concat(res.data)
          })
          .catch(err => {
            console.log(err)
          })
      },
      initRealData() {
        let group_type = this.lang === 'pt' ? 'brazil' : 'other'
        this.real_time_page = this.real_time_page + 1
        get_leader_board_list({
          group_type,
          board_type: 'realtime',
          // page: this.real_time_page,
          size: 100
        })
          .then(res => {
            console.log(res)
            this.leaderRealList = this.leaderRealList.concat(res.data)
            this.scroll_style = {
              width: 300 * (res.data.length > 10 ? 10 : res.data.length) + 'px'
            }
            this.newsList = res.data.slice(0, 10)
          })
          .catch(err => {
            console.log(err)
          })
      },
      changeSchedule(name) {
        this.$refs.schedule.changeSchedule(name)
      },
      changeZone(zone) {
        this.$refs.schedule.changeData(zone)
      }
    },
    created() {
      this.bannerImg = {
        backgroundImage: 'url(/ppst/static/img/ppst/banner_' + this.lang + '.jpg)'
      }
      this.realtimeImg = {
        backgroundImage: 'url(/ppst/static/img/ppst/realtime_' + this.lang + '.png)'
      }

      this.$i18n.locale = this.lang
    },
    mounted() {
      this.initOverData()
      this.initRealData()
      this.initCycle()

      this.toFloat()
      window.addEventListener('scroll', () => {
        this.toFloat()
      })
    }
  }
</script>

<style lang="scss">
  .ppst {
    .time_zone {
      ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
        background-color: transparent;
      }
      ::-webkit-scrollbar-track {
        border-radius: 0;
      }
      ::-webkit-scrollbar-thumb {
        border-radius: 0;
        background-color: #0f9a68;
        transition: all .2s;
        border-radius: 0rem;
      }
      ::-webkit-scrollbar-thumb:hover {
        background-color: #0f9a68;
      }
    }


    .vb>.vb-dragger {
      z-index: 5;
      width: 10px;
      right: 0;
    }

    .vb>.vb-dragger>.vb-dragger-styler {
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      -webkit-transform: rotate3d(0, 0, 0, 0);
      transform: rotate3d(0, 0, 0, 0);
      -webkit-transition:
        background-color 100ms ease-out,
        margin 100ms ease-out,
        height 100ms ease-out;
      transition:
        background-color 100ms ease-out,
        margin 100ms ease-out,
        height 100ms ease-out;
      background-color: rgba(7, 117, 148, .1);
      margin: 5px 5px 5px 0;
      // border-radius: 20px;
      height: calc(100% - 10px);
      display: block;
    }

    .vb.vb-scrolling-phantom>.vb-dragger>.vb-dragger-styler {
      background-color: #0f9a68;
    }

    .vb>.vb-dragger>.vb-dragger-styler {
      background-color: #0f9a68;
      margin: 0px;
      height: 100%;
    }

    .vb.vb-dragging>.vb-dragger>.vb-dragger-styler {
      background-color: #0f9a68;
      margin: 0px;
      height: 100%;
    }

    .vb.vb-dragging-phantom>.vb-dragger>.vb-dragger-styler {
      background-color: #0f9a68;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .ppst {
    .ppst-color-main {
      color: #00ffa8;
    }

    .ppst-color-second {
      color: #23c0ec;
    }

    .ppst-color-para {
      color: #cbebef;
    }

    .header {
      background-color: #000000;
      padding: 30px 0px;
    }

    .banner {
      height: 512px;
      background-position: center center;
      background-repeat: no-repeat;
    }

    .content {
      background-color: #002d32;
      padding-bottom: 80px;
      background-image: url("/ppst/static/img/ppst/BG_01.jpg"), url("/ppst/static/img/ppst/BG_02.jpg"), url("/ppst/static/img/ppst/BG_03.jpg"), url("/ppst/static/img/ppst/BG_04.jpg");
      background-repeat: no-repeat, no-repeat, no-repeat, no-repeat;
      background-position: center 0px, center 926px, center 1853px, center 2779px;

      .container {
        position: relative;
        padding-top: 2px;
      }

      .ppst-float.fixed {
        position: fixed;
      }

      .ppst-float {
        position: absolute;
        top: 160px;
        left: 50%;
        margin-left: -580px;
        width: 160px;
        text-align: center;
        z-index: 4;

        .realtime {
          position: relative;
          width: 158px;
          height: 26px;
          display: block;
          margin: 0px auto;
          margin-bottom: 40px;
          background-size: 100% auto;
          background-repeat: no-repeat;
          padding-top: 34px;
          cursor: pointer;

          .realtime_scroll {
            position: relative;
            height: 24px;
            width: 130px;
            margin: 0px auto;
            .realtime_scroll_seam {
              overflow: hidden;
              height: 24px;
              width: 100%;
              .item {
                width: 1000px;
              }
              .scroll_p {
                display: inline-block;
                line-height: 24px;
                font-size: 14px;
                color: #a8ffb5;
                width: 300px;
                text-align: left;
                float: left;
              }
            }

          }
        }

        .tab_side {
          width: 100%;
          height: 173px;
          background: url('/ppst/static/img/ppst/tab_side.png') center top;
          background-size: 100% auto;
          background-repeat: no-repeat;

          .tab_side_item {
            width: 100%;
            height: 57px;
            // display: flex;
            // justify-content: flex-start;
            // align-items: center;
            cursor: pointer;
            position: relative;

            p {
              padding: 0px 8px;
              margin: 0px;
              text-align: left;
              color: #afccd4;
              font-size: 16px;
              position:absolute;
              left:0px;

              top:50%;
              transform:translate(0%,-50%);
            }
          }

          .tab_side_item.active {
            background: url('/ppst/static/img/ppst/tab_side_light.png') center top;
            background-size: 100% 100%;
            background-repeat: no-repeat;

            p {
              color: #ffffff;
            }
          }
        }

        a {
           display: block;
           width: 100%;
           height: 57px;
           overflow: hidden;
           margin-top: 40px;
        }
        .join_img {
          width: 100%;
          height: 57px;
          display: block;
          margin: 0px auto;
          cursor: pointer;
        }

        .tab_tips {
          font-size: 12px;
          margin-top: 6px;
          color: #afccd4;
          text-align: center;
        }
      }

      @media screen and (max-width: 1200px) {
          .ppst-float {
              margin-left: 0px;
              left: 20px;
          }
      }

      .content-right {
        padding-left: 220px;
        width: 958px;
        color: #cbebef;

        p {
          font-size: 16px;
          line-height: 20px;
          margin-bottom: 10px;
        }

        .line-green {
          width: 100%;
          height: 1px;
          background: url("/ppst/static/img/ppst/title_line_green.png") center top;
          margin: 4px 0px 40px 0px;
        }

        .line-blue {
          width: 100%;
          height: 1px;
          background: url("/ppst/static/img/ppst/title_line_blue.png") center top;
          margin: 4px 0px 40px 0px;
        }

        .to_link {
          box-shadow: 0 1px;
          color: #cbebef;
          &:hover {
            color: #00ffa8;
          }
        }

        .title {
          font-weight: 700;
          font-size: 40px;
          line-height: 50px;
          margin-top: 90px;
          margin-bottom: 0px;
        }

        .leaderboard {
          margin-top: 80px;
          width: 100%;
          position: relative;

          .tab {
            width: 400px;
            height: 40px;
            background: url('/ppst/static/img/ppst/tab.png') center center;
            background-repeat: no-repeat;

            .tab_item {
              display: inline-block;
              width: 200px;
              height: 40px;
              cursor: pointer;
              text-align: center;

              p {
                line-height: 40px;
                margin: 0px;
                color: #00ffa8;
              }
            }

            .tab_item.active {
              background: url('/ppst/static/img/ppst/tab_light.png') center center;
              background-repeat: no-repeat;

              p {
                color: #0f7d43;
              }
            }
          }

          .serach {
            position: absolute;
            right: 0px;
            top: 10px;
            width: 285px;
            height: 30px;
            background: url('/ppst/static/img/ppst/seach.png') left center;
            background-repeat: no-repeat;
            overflow: hidden;
            padding-left: 35px;

            .serach_input::-webkit-input-placeholder {
              /* WebKit browsers */
              color: #005737;
              font-weight: 400;
            }

            .serach_input:-moz-placeholder {
              /* Mozilla Firefox 4 to 18 */
              color: #005737;
              font-weight: 400;
            }

            .serach_input::-moz-placeholder {
              /* Mozilla Firefox 19+ */
              color: #005737;
              font-weight: 400;
            }

            .serach_input:-ms-input-placeholder {
              /* Internet Explorer 10+ */
              color: #005737;
              font-weight: 400;
            }

            .serach_input {
              border: none;
              outline: none;
              background-color: rgba(0, 0, 0, 0);
              height: 30px;
              width: 100%;
              margin: 0px;
              padding: 0px;
              color: #00c37c;
              font-size: 16px;

              &:focus {
                border: none;
              }
            }
          }
        }

        .leadertable {
          margin-top: 20px;
          background-color: #1b5c44;
          height: 700px;
          // height: 300px;

          .table {
            width: 100%;
            height: 100%;
            // background: url('/ppst/static/img/ppst/leaderboard_bg.png') center 4px;
            // background-size: 100% auto;
            // background-repeat: no-repeat;

            .table-header {
              background-color: #08e07d;
              // width: calc(100% - 10px);

              .td {
                padding: 20px 0px;
                text-align: left;
                vertical-align: top;
                display: inline-block;

                p {
                  // padding: 0px 14px;
                  margin: 0px;
                  font-size: 22px;
                  color: #ffffff;
                  font-weight: 500;
                }
              }
              .td.td_geo_h {
                width: 10%;
              }

            }

            .no_record {
              margin-top: 93px;
              .no_record_p {
                position: relative;
                top: 49%;
                text-align: center;
                line-height: 21px;
                img {
                  display: inline-block;
                  vertical-align: middle;
                  width: 21px;
                  height: 21px;
                  margin-right: 5px;
                }
                span {
                  line-height: 21px;
                  font-size: 16px;
                  display: inline-block;
                  vertical-align: middle;
                }
              }
            }

            .table-item {
              // width: calc(100% - 10px);

              background-color: #1b5c44;

              .td {
                padding: 12px 0px;
                text-align: left;
                vertical-align: top;
                overflow: hidden;

                p {
                  // padding: 0px 20px;
                  margin: 0px;
                }
              }
            }

            .table-item:nth-child(2n + 1) {
              background-color: #1e6d50;
            }

            .td1 {
              width: 15%;
              display: inline-block;

              p {
                color: #bfeddc;
                padding-left: 30px;
              }
            }

            .td2 {
              width: 17%;
              display: inline-block;

              p {
                color: #bfeddc;
              }
            }

            .td3 {
              width: 25%;
              display: inline-block;

              p {
                color: #00ffa8;
              }
            }

            .td4 {
              width: 15%;
              display: inline-block;

              p {
                color: #bfeddc;
              }
            }
            .td5 {
              width: 18%;
              display: inline-block;

              p {
                color: #bfeddc;
              }
            }
            .td.td_geo {
              width: 10%;
              display: inline-block;
              padding: 0px;
              img {
                width: 36px;
                display: block;
                margin-top: 4px;
              }
              p {
                color: #bfeddc;
              }
            }
          }
        }

        .realtimetable {
          margin-top: 20px;
          background-color: #1b5c44;
          height: 700px;
          position: relative;

          .table {
            width: 100%;
            height: 100%;
            // background: url('/ppst/static/img/ppst/leaderboard_bg.png') center -4px;
            // background-size: 100% auto;
            // background-repeat: no-repeat;

            .table-header {
              background-color: #08e07d;
              // width: calc(100% - 10px);

              .td {
                padding: 20px 0px;
                text-align: left;
                vertical-align: top;
                display: inline-block;

                p {
                  // padding: 0px 14px;
                  margin: 0px;
                  font-size: 22px;
                  color: #ffffff;
                  font-weight: 500;
                }
              }
              .td.td_geo_h {
                width: 12%;
              }
            }

            .no_record {
              margin-top: 93px;
              .no_record_p {
                position: relative;
                top: 49%;
                text-align: center;
                line-height: 21px;
                img {
                  display: inline-block;
                  vertical-align: middle;
                  width: 21px;
                  height: 21px;
                  margin-right: 5px;
                }
                span {
                  line-height: 21px;
                  font-size: 16px;
                  display: inline-block;
                  vertical-align: middle;
                }
              }
            }

            .table-item {
              // width: calc(100% - 10px);

              background-color: #1b5c44;

              .td {
                padding: 12px 0px;
                text-align: left;
                vertical-align: top;
                overflow: hidden;
                p {
                  // padding: 0px 20px;
                  margin: 0px;
                }
              }
            }

            .table-item:nth-child(2n + 1) {
              background-color: #1e6d50;
            }

            .td1 {
              width: 20%;
              display: inline-block;

              p {
                color: #bfeddc;
                padding-left: 30px;
              }
            }

            .td2 {
              width: 20%;
              display: inline-block;

              p {
                color: #bfeddc;
              }
            }

            .td3 {
              width: 28%;
              display: inline-block;

              p {
                color: #00ffa8;
              }
            }

            .td5 {
              width: 20%;
              display: inline-block;

              p {
                color: #bfeddc;
              }
            }
            .td.td_geo {
              width: 12%;
              display: inline-block;
              padding: 0px;
              img {
                width: 36px;
                display: block;
                margin-top: 4px;
              }
              p {
                color: #bfeddc;
              }
            }
          }
        }

        .realtime_tips {
          font-size: 14px;
          margin-top: 8px;
          margin-bottom: 0px;
          a {
            font-size: 14px;
          }
        }

        .prizetable_img {
          display: block;
          margin-top: 40px;
          width: 100%;
        }


        .div-faq {
          p {
            padding-left: 18px;
          }

          p img {
            display: inline-block;
            line-height: 20px;
            margin-top: 6px;
            vertical-align: top;
            margin-left: -18px;
            margin-right: 10px;
          }
        }
      }
    }
  }
</style>
